import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormField, FormErrorPipe } from '@teamfoster/dynamic-forms';
import { Subject, takeUntil } from 'rxjs';
import { MatFormField, MatLabel, MatInput, MatPrefix, MatSuffix, MatHint, MatError } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-form-input-v2',
  templateUrl: './form-input-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    NgClass,
    MatLabel,
    MatInput,
    MatIcon,
    MatPrefix,
    MatSuffix,
    MatHint,
    MatError,
    FormErrorPipe,
  ],
})
export class FormInputV2Component implements OnInit, OnDestroy {
  private cd = inject(ChangeDetectorRef);

  config!: DynamicFormField;
  group!: UntypedFormGroup;
  private _unsubscribe = new Subject<void>();

  ngOnInit(): void {
    // status updates not updating dom.. bugfix
    this.group
      .get(this.config.name)
      ?.statusChanges.pipe(takeUntil(this._unsubscribe))
      .subscribe(a => {
        this.cd.markForCheck();
      });
  }

  get iconClass() {
    const prefixClass = this.config.matPrefix ? 'has--prefix-icon' : '';
    const suffixClass = this.config.matSuffix ? 'has--suffix-icon' : '';

    return `${prefixClass} ${suffixClass}`;
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}
